<template>
  <v-row dense class="text--primary body-1 font-weight-medium">
    <v-col cols="12" sm="3" class="d-flex align-center">
      <px-span-tooltip
        top
        :text="labelAprovacaoCodigo"
        :tooltip="tooltipAprovacaoCodigo"/>
      &nbsp;{{ aprovacao.comprador.pessoa.nome }}
      <px-situacao-aprovacao-icon :situacao="aprovacao.situacao"/>
    </v-col>
    <v-col cols="12" sm="3" class="d-flex justify-center flex-column">
      {{ nomeFornecedor | truncate(35) }}
      <small>
        Fornecedor
      </small>
    </v-col>
    <v-col cols="12" sm="2" class="d-flex align-center">
      {{ solicitante | truncate(20) }}
    </v-col>
    <v-col cols="12" sm="1" class="d-flex justify-center flex-column">
      {{ aprovacao.createdIn | date }}
      <small>
        Criado em
      </small>
    </v-col>
    <v-col cols="12" sm="2" class="d-flex justify-center flex-column">
      {{ aprovacao.valorMoedaConvertido.total | currency }}
      <small>
        Total
      </small>
    </v-col>
    <v-col cols="12" sm="1" class="d-flex align-center justify-end">
      <div class="d-inline">
        <template>
          <px-aprovacao-compra-menu-options
            v-if="showToAprovador || showToComprador"
            :show-gerar-nova-compra="shouldShowGerarNovaCompra"
            :aprovacao="aprovacao"/>
        </template>
        <px-aprovacao-compra-detalhes-dialog-view :aprovacao-id="aprovacao.id"
                                                  @update="onUpdate"/>
        <px-aprovacao-compra-controls :aprovacao="aprovacao"
                                      @update="onUpdate"/>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import AprovacaoCompraDetalhesDialogView
  from '@/modules/aprovacao-compra/detalhes/AprovacaoCompraDetalhesDialogView.vue';
import pxAprovacaoCompraControls
  from '@/modules/aprovacao-compra/components/AprovacaoCompraControls.vue';
import { OrigemCompra, SituacaoAprovacao } from 'px-business-components';
import AprovacaoCompraMenuOptions
  from '@/modules/aprovacao-compra/components/AprovacaoCompraMenuOptions.vue';
import { mapGetters } from 'vuex';

export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['hasRoleAprovador', 'hasRoleComprador']),
    solicitante() {
      return this.aprovacao.usuario ? this.aprovacao.usuario.nome : this.aprovacao.nomeResponsavel;
    },
    labelAprovacaoCodigo() {
      return this.aprovacao.codigoInterno ? `(${this.aprovacao.codigoInterno} / ${this.aprovacao.id}) ` : `(${this.aprovacao.id}) `;
    },
    tooltipAprovacaoCodigo() {
      return this.aprovacao.codigoInterno ? 'Código ERP / Código Proxpect' : 'Código Proxpect';
    },
    shouldShowGerarNovaCompra() {
      return this.isFinalizada && this.isOrigemCadastro && this.hasProdutosRecusados;
    },
    isFinalizada() {
      return [SituacaoAprovacao.keys.RECUSADO.key,
        SituacaoAprovacao.keys.APROVADO.key].includes(this.aprovacao.situacao);
    },
    hasProdutosRecusados() {
      return this.aprovacao.produtos.some(item => item.situacao
        === SituacaoAprovacao.keys.RECUSADO.key);
    },
    isOrigemCadastro() {
      return this.aprovacao.origemCompra === OrigemCompra.keys.CADASTRO.key;
    },
    nomeFornecedor() {
      return this.aprovacao.nomeInternoFornecedor || this.aprovacao.fornecedor.pessoa.nome;
    },
    showToComprador() {
      return this.shouldShowGerarNovaCompra && this.hasRoleComprador;
    },
    showToAprovador() {
      return this.canGerarCompraParcial() && this.hasRoleAprovador;
    },
  },
  methods: {
    canGerarCompraParcial() {
      return this.aprovacao.produtos.some(
        item => item.situacao === SituacaoAprovacao.keys.APROVADO.key && !item.itemCompraProduto,
      );
    },
    onUpdate(aprovacaoAtualizada) {
      this.$emit('update', aprovacaoAtualizada);
    },
  },
  components: {
    pxAprovacaoCompraControls,
    pxAprovacaoCompraDetalhesDialogView: AprovacaoCompraDetalhesDialogView,
    pxAprovacaoCompraMenuOptions: AprovacaoCompraMenuOptions,
  },
};
</script>
